import React from "react";
import Zoom from 'react-medium-image-zoom'
import '../css/zoom-styles.css'
import imageList from "../artworks/imagelist.json";
import {Container} from "react-bootstrap";
import Masonry from "react-masonry-css";
import {NavLink} from "react-router-dom";

const Artworks = () => {
    const items = imageList.map(function(item) {
        return <div className="mb-3" key={item}>
            <Zoom><img className="img-fluid card-img-top" src={require("../artworks/" + item)}/></Zoom>
        </div>
    });

    const myBreakpointsAndCols = {
        default: 4,
        1100: 3,
        700: 2,
        500: 1
    }

    return (
        <>
            <div className={"artworks-container"}>
                <nav>
                    <ul>
                        <li><NavLink style={{color: '#fee4ee'}} to='/'>ARTWORKS</NavLink></li>
                        <li><NavLink to='/designs'>DESIGNS</NavLink></li>
                        <li><NavLink to='/about'>ABOUT</NavLink></li>
                    </ul>
                </nav>
                <Container>
                    <div className={"dropdown-shadow-artworks"}>
                    <Masonry
                        breakpointCols={myBreakpointsAndCols}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column"
                    >
                        {items}
                    </Masonry>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Artworks;